import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { TabButtons, TabHealthera } from '../../../../healtheraComponents';

const routes = [
  { path: '/clinics', tab: 0, label: 'Clinics' },
  { path: '/clinics/master-medicines', tab: 1, label: 'Master medicines' },
  { path: '/clinics/questionnaires', tab: 2, label: 'Questionnaires' },
  { path: '/clinics/conditions', tab: 3, label: 'Conditions' },
];

const getActiveTab = url => {
  return routes.find(({ path }) => url === path)?.tab ?? null;
};

const getRouteByTab = tabIndex => {
  return routes.find(({ tab }) => tab === tabIndex)?.path;
};

function ClinicsSearchTabs() {
  const location = useLocation();
  const history = useHistory();

  function handleTabChange(_, tabIndex) {
    const selectedTab = getActiveTab(location.pathname);
    if (selectedTab === tabIndex) return;
    history.push(getRouteByTab(tabIndex) || '/');
  }

  const activeTab = getActiveTab(location.pathname);
  if (activeTab === null) return null;

  return (
    <TabButtons height={`64px`} value={activeTab} onChange={handleTabChange}>
      {routes.map(route => (
        <TabHealthera key={route.path} label={route.label} />
      ))}
    </TabButtons>
  );
}

export default ClinicsSearchTabs;
